export default __webpack_public_path__ + "static/media/CaretRight.35c17fc5.svg";